import { ObjectId } from 'bson';

const addDaysToDate = (date, days) => {
  const wholeDays = Math.floor(days || 0);
  date.setDate(date.getDate() + wholeDays);
  if (days > wholeDays + 0.000001) {
    const seconds = Math.round(24.0 * 60.0 * 60.0 * (days - wholeDays));
    date.setSeconds(date.getSeconds() + seconds);
  }
};

const groupChallengeCompletedTimestampPlusDays = (groupChallenge, days) => {
  const unlockDate = (groupChallenge && groupChallenge.completed)
    ? new Date(groupChallenge.completed)
    : new Date(Date.now() + 1);
  addDaysToDate(unlockDate, days);
  return unlockDate;
};

/** returns unlock Date given the group and the lock */
export const getGroupUnlockDate = (group, lock) => {
  if (!lock) return new Date();
  if (lock.relative && group && group.challenges) {
    if (lock.outro) {
      return groupChallengeCompletedTimestampPlusDays(group.challenges[lock.challengeIndex], lock.days);
    } else if (lock.challengeIndex > 0) {
      // non-outro challenge locks should use the previous challenge completed timestamp, if it exists
      return groupChallengeCompletedTimestampPlusDays(group.challenges[lock.challengeIndex - 1], lock.days);
    }
    // relative non-outro lock on first challenge (so no previous challenge completed timestamp exists)
    // try to use group creation time as relative Date, fallback to now.
    // NOTE: falling back to now means it will always be locked if lock.days > 0
    const unlockDate =
      (group._id)
        ? ((group._id.getTimestamp)
          ? group._id.getTimestamp()
          : (new ObjectId(group._id)).getTimestamp())
        : new Date();
    addDaysToDate(unlockDate, lock.days);
    return unlockDate;
  }
  return new Date(lock.unlockDate);
};

/** returns whether group is locked by the given lock */
export const isGroupLocked = (group, lock) => (getGroupUnlockDate(group, lock).getTime() > Date.now());



// WEBPACK FOOTER //
// ./src/utils/challenge-locks.js